import { Controller } from "stimulus";
import { getActiveCurrency, formatCurrency } from "../../util/currency";
import { EventCurrencyChanged, EventDarkMode, EventPrivacyModeToggled } from "../../events";
import Cookies from "js-cookie";

export default class extends Controller {
  static targets = ["pieChart"];

  connect() {
    this._loadPieChart();
    window.addEventListener(EventCurrencyChanged, e => this._loadPieChart());
    window.addEventListener(EventDarkMode, e => this._loadPieChart());
    // when privacy mode is toggled, loadPieChart, some data in tooltip is hidden
    window.addEventListener(EventPrivacyModeToggled, e => this._loadPieChart());
  }

  _loadPieChart() {
    let labelColor = Cookies.get("is_dark") === "true" ? "white" : "black";
    let _this = this

    Promise.all([import("highcharts/highstock")]).then(res => {
      const [Highcharts] = res;
      Highcharts.chart({
        time: { useUTC: false },
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          height: 310,
          renderTo: this.pieChartTarget.id,
          className: "cg-highcharts"
        },
        credits: {
          enabled: false
        },
        title: {
          text: ""
        },
        tooltip: {
          useHTML: true,
          formatter: function() {
            let balance = fx(this.point.balance_btc)
              .from("btc")
              .to(getActiveCurrency());

            if (_this._privacyModeOn()) {
              return `<b>${this.key} (${Math.round(this.point.percentage)}%)</b><br>`
            } else {
              return `<b>${this.key} (${Math.round(this.point.percentage)}%)</b><br>
                    ${formatCurrency(balance, getActiveCurrency())}<br>
                    ${this.point.quantity}`;
            }
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            colors: [
              "#8bc34a",
              "#03a9f4",
              "#ffc107",
              "#ff9800",
              "#673ab7",
              "#9c27b0",
              "#e91e63",
              "#009688",
              "#3f51b5",
              "#795548"
            ],
            borderColor: null,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %",
              style: {
                color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || labelColor,
              }
            },
            animation: false
          }
        },
        series: [
          {
            name: "Percentage Volume",
            dataLabels: {
              style: {
                fontSize: 12
              }
            },
            colorByPoint: true,
            size: "80%",
            innerSize: "80%",
            data: JSON.parse(this.element.getAttribute("data-holdings-breakdown"))
          }
        ]
      });
    });
  }

  _privacyModeOn() {
    return Cookies.get("portfolioPrivacyMode") === "true"
  }
}
